import
  React
from 'react';

import {
  Base,
  ColorSvg,
  HContainer,
  Image,
  Text,
  VContainer,
  VContainerVH
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  CustomColors,
  ErrorKeys,
  Icons
} from '../../../constants';

import {
  SecondaryButton
} from 'components';

import {
  HandleRender
} from 'hocs';

export const WeatherWidgetDetail = props => {

  return (

    <HandleRender
      isLoading={false}
      isError={props.forecast?.length === 0}
      error={{ type: ErrorKeys.General, title: 'DETAILED WEATHER CARD' }}>

      <VContainer
        boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
        borderRadius={'4px'}
        padding={'16px 15px'}>

        <HContainer
          padding={'0 0 0 0'}>

          <Base
            display={'flex'}
            alignItems={'center'}>

            <Text
              fontSize={'20px'}
              fontWeight={'500'}
              color={CustomColors.Grey11}
              whiteSpace={'nowrap'}>

              {props?.city}
            </Text>
          </Base>

          <Base
            width={'100%'}
            display={'flex'}
            justifyContent={'flex-end'}>

            <SecondaryButton
              width={'119px'}
              maxWidth={'119px'}
              text={'Change City'}
              onClick={() => {

                props.setState(prevState => ({
                  ...prevState,
                  isChangeCityOpen: true
                }));
              }}/>

          </Base>
        </HContainer>

        <HContainer
          padding={'20px 0 0 0'}>

          <VContainerVH
            padding={'0 0 0 10px'}>

            <Image
              src={`${Environment.current.assetPath}images/icons/weather/${props.forecast?.[0]?.icon}.svg`}
              width={'130px'}
              height={'130px'} />
          </VContainerVH>

          <Base
            width={'100%'}
            display={'flex'}
            justifyContent={'flex-end'}
            padding={'0 19px 0 0'}>

            <VContainer
              alignItems={'center'}
              padding={'0 0 15px 0'}
              justifyContent={'center'}>

              <HContainer
                margin={'31px 0 0 0'}
              >

                <Text
                  margin={'16px 0 0 0'}
                  fontSize={'48px'}
                  fontWeight={'bold'}
                  color={CustomColors.Grey11}>

                  {`${props.forecast[0]?.temperature || '15'}`}
                </Text>

                <Base
                  display={'flex'}
                  margin={'5px 0 0 0'}>

                  <Text
                    fontSize={'20px'}
                    fontWeight={'bold'}
                    color={CustomColors.Grey11}>

                    {'\xB0C'}
                  </Text>
                </Base>
              </HContainer>

              <Base
                margin={'7px 0 0 0'}>

                <Text
                  fontSize={'20px'}
                  fontWeight={'500'}
                  color={CustomColors.Grey11}>

                  {props.forecast[0]?.date}
                </Text>
              </Base>
            </VContainer>
          </Base>
        </HContainer>

        <HContainer
          justifyContent={'space-evenly'}
          margin={'24px 0 18px 0'}>

          <VContainer
            justifyContent={'space-between'}
            alignItems={'center'}>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>

              {'Humidity'}
            </Text>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>

              {`${props.forecast[0]?.humidity}%`}
            </Text>
          </VContainer>

          <VContainer
            justifyContent={'space-between'}
            alignItems={'center'}>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>

              {'Wind Direction'}
            </Text>

            <HContainer>
              <Text>
                {props.forecast[0]?.windDirectionLetter}
              </Text>

              <ColorSvg
                margin={'0 0 0 5px'}
                color={CustomColors.Black}
                transform={`rotate(-${props.forecast[0]?.windDirection}deg)`}
                src={Icons.North}
                width={'16px'}
                height={'16px'} />
            </HContainer>
          </VContainer>

          <VContainer
            justifyContent={'space-between'}
            alignItems={'center'}>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>

              {'Wind speed'}
            </Text>

            <Text
              fontSize={'16px'}
              color={CustomColors.Grey9}>

              {`${props.forecast[0]?.windSpeed}KM/h`}
            </Text>
          </VContainer>
        </HContainer>
      </VContainer>
    </HandleRender>
  );
};